import { ViewContainerRef, ViewRef } from '@angular/core';

import { Subject, Observable } from 'rxjs';
import { cloneDeep } from 'lodash';

import {
  AbstractControl,
  ControlDataModel,
  ControlSpecification,
  ControlLayoutModel,
  ControlViewModel,
  LoadComponentModel,
  DynamicControlContainer,
  AbstractValueControlBase,
  ValueControlViewModel
} from '../types';
import { LayoutHostDirective } from '../components/layout-host.directive';
import { ControlValidatorService } from '../services/control-validator.service';
import { isNullOrUndefined } from './utils';

import { ControlValidatorType, ControlValidator } from '../types/validator.types';
import { UnionCHeckValidator } from '../validators/validators/union-check-validators';
/**
 * æ§ä»¶è½¬æ¢
 *
 */
export interface ControlTranslate {
  /**
   * æ¯å¦ç¦ç¨æ§ä»¶æä½
   *
   */
  disableOperateControl: boolean;

  /**
   * æ§ä»¶å è½½modeläºä»¶
   *
   */
  loadComponentModel$: Observable<LoadComponentModel>;

  /**
   * æ§ä»¶è§£æå®æ
   */
  controlResolved: Subject<AbstractControl<ControlViewModel>>;

  /**
   * æ§ä»¶ç§»é¤äºä»¶
   */
  controlRemoved$: Observable<AbstractControl<any>>;

  /**
   * åéæ§ä»¶å è½½model
   *
   */
  sendLoadComponentModel(data: LoadComponentModel): void;
  /**
   * åéæ§ä»¶ç§»é¤äºä»¶
   *
   */
  sendControlRemoved(control: AbstractControl<any>): void;

  /**
   *  ä½¿ç¨LoadComponentModelå è½½ç»ä»¶
   *
   */
  loadComponentsByModel(loadModel: LoadComponentModel): AbstractControl<any> | AbstractControl<any>[];
  /**
   * @description æ ¹æ®æ§ä»¶DataModelsçææ§ä»¶, å½dataModelsä¸ºç©ºæ¶ï¼è¿åç©ºæ°ç»
   *
   * @param  dataModels è¦çæçæ§ä»¶DataModels
   * @param  viewContainerRef ä¾èµçè§å¾å®¹å¨
   * @param  [isDesign] æ¯å¦æ¯è®¾è®¡æ¶
   * @returns å·²æ·»å çæ§ä»¶éå
   * @memberof ControlTranslateService
   */
  loadComponents(
    dataModels: Array<ControlDataModel>,
    controlLayoutHost: DynamicControlContainer,
    isDesign?: boolean
  ): Array<AbstractControl<any>>;
  /**
   * æ ¹æ®æ§ä»¶å¸å±Modelçææ§ä»¶ï¼å¦ælayoutModelä¸ºç©ºï¼åè¿ånull
   *
   * @param  layoutModel æ§ä»¶å¸å±model
   * @param  viewContainerRef ä¾èµçè§å¾å®¹å¨
   * @param  [isDesign] æ¯å¦æ¯è®¾è®¡æ¶
   * @returns å·²æ·»å çæ§ä»¶éå
   * @memberof ControlTranslateService
   */
  loadComponent(
    layoutModel: ControlLayoutModel,
    dynamicControlContainer: DynamicControlContainer,
    isDesign?: boolean
  ): AbstractControl<any>;
}

/**
 * è½¬æ¢æ§ä»¶è¯´æå°å¸å±model
 *
 */
export function translateControlSpecitification2LayoutModel(data: ControlSpecification): ControlLayoutModel {
  return {
    component: data.component,
    type: data.name,
    model: data.defaultModel ? cloneDeep(data.defaultModel) : {},
    children: []
  };
}

/**
 * è½¬æ¢æ§ä»¶å°æ§ä»¶DataModel
 *
 */
export function translateControl2ControlDataModel(control: AbstractControl<any>): ControlDataModel {
  return {
    model: cloneDeep(control.model),
    type: control.type,
    children: []
  };
}

/**
 * ä»è§å¾ä¸ç§»é¤æ§ä»¶
 *
 * @param  viewContainerRef ä¾èµçè§å¾å®¹å¨
 * @param  [index] æ§ä»¶å¨è§å¾çä¸­çindex
 * @memberof ControlTranslateService
 */
export function removeComponent(viewContainerRef: ViewContainerRef, index?: number) {
  viewContainerRef.remove(index);
}

export function removeControl(index: number, layoutHost: LayoutHostDirective, children: AbstractControl<any>[]) {
  children.splice(index, 1);
  removeComponent(layoutHost.viewContainerRef, index);
}

export function moveUpViewRef(
  hostView: ViewRef,
  layoutHost: LayoutHostDirective,
  children: AbstractControl<any>[]
): void {
  const index = layoutHost.viewContainerRef.indexOf(hostView);
  if (index <= 0) {
    return;
  }
  layoutHost.viewContainerRef.move(hostView, index - 1);
  const original = children[index];
  children[index] = children[index - 1];
  children[index - 1] = original;
}

export function moveDownViewRef(
  hostView: ViewRef,
  layoutHost: LayoutHostDirective,
  children: AbstractControl<any>[]
): void {
  const index = layoutHost.viewContainerRef.indexOf(hostView);
  if (index < 0 || index >= layoutHost.viewContainerRef.length) {
    return;
  }
  layoutHost.viewContainerRef.move(hostView, index + 1);
  const original = children[index];
  children[index] = children[index + 1];
  children[index + 1] = original;
}

/**
 * è®¾ç½®æ§ä»¶çéªè¯å¨
 *
 */
export function setControlValidator(
  control: AbstractControl<ControlViewModel>,
  controlValidatorService: ControlValidatorService
) {
  // è®¾ç½®validator
  const valueControl = control as AbstractValueControlBase<any>;
  if (valueControl.getValidators && typeof valueControl.getValidators === 'function') {
    if (!valueControl.model.validators) {
      valueControl.model.validators = {};
    }
    valueControl.validators = valueControl.getValidators(controlValidatorService);
  }
}

/**
 * ç»å®æ§ä»¶æ§ä»¶çº§èå±æ§
 */
export function bindUnionCheck(control: AbstractControl<ControlViewModel>, controls: AbstractControl<any>[]): void {
  const validators = (control as AbstractValueControlBase<ValueControlViewModel>).validators;
  if (!validators) return;

  const unionCheckValidator = (validators.find(
    (s) => s.type === ControlValidatorType.UnionCheck
  ) as unknown) as UnionCHeckValidator;

  if (unionCheckValidator) {
    const targetControl = findControlByName(unionCheckValidator.model.unionId, controls) as AbstractValueControlBase<
      any
    >;

    if (!targetControl) {
      return;
    }

    // tslint:disable-next-line: no-unused-expression
    targetControl.valueChanged$ &&
      targetControl.valueChanged$.subscribe((valid) => {
        unionCheckValidator.validate();
      });
    unionCheckValidator.bindUnionTargetControl(targetControl);
  }
}

/**
 * æ ¹æ®æ§ä»¶åç§°æ¥æ¾æ§ä»¶
 */
export function findControlByName(
  controlName: string,
  controls: AbstractControl<ControlViewModel>[]
): AbstractControl<ControlViewModel> {
  return controlsTraversalPipeReturn<AbstractControl<ControlViewModel>>(controls, (c) => {
    if (c.model.name === controlName) {
      return c;
    }
    return null;
  });
}

/**
 * æ§ä»¶éåç®¡éï¼ä¼éå½éåæ§ä»¶çææå­æ§ä»¶ï¼å¹¶æ§è¡ç®¡éä¸­çå½æ°
 * @param controls è¦éåçæ§ä»¶
 * @param funcs å¤çå½æ°æ°ç»
 */
export function controlsTraversalPipe(
  controls: AbstractControl<ControlViewModel>[],
  ...funcs: ((control: AbstractControl<ControlViewModel>) => void)[]
) {
  if (!controls || controls.length === 0) {
    return;
  }
  controls.forEach((control) => {
    // fix: ç§»é¤å¯¹desighostå¤ç
    if (control.type === 'DesignHost') {
      control = control[`control`];
    }

    funcs.forEach((s) => {
      s(control);
    });
    if (control.children && control.children.length > 0) {
      controlsTraversalPipe(control.children, ...funcs);
    }
  });
}

/**
 * æ§ä»¶éåç®¡éï¼ä¼éå½éåæ§ä»¶çææå­æ§ä»¶ï¼å¹¶æ§è¡ç®¡éä¸­çå½æ°,è¿åå½æ°è¿åå¼ä¸ä¸ºnullæèundefinedçå¼æ¶åæ­¢æ§è¡
 * @param controls è¦éåçæ§ä»¶
 * @param funcs å¤çå½æ°æ°ç»
 */
export function controlsTraversalPipeReturn<T>(
  controls: AbstractControl<any>[],
  func: (control: AbstractControl<any>) => T
): T {
  if (!controls || controls.length === 0) {
    return null;
  }
  for (let control of controls) {
    // fix: ç§»é¤å¯¹desighostå¤ç
    if (control.type === 'DesignHost') {
      control = control[`control`];
    }
    const value = func(control);
    if (!isNullOrUndefined(value)) {
      return value;
    }

    if (control.children && control.children.length > 0) {
      const returnValue = controlsTraversalPipeReturn<T>(control.children, func);
      if (!isNullOrUndefined(returnValue)) {
        return returnValue;
      }
    }
  }
  return null;
}

/**
 * æ¸ç©ºæ°æ®æºä¸­çæ§ä»¶æ è¯
 */
export function clearControlIdentityCode(dataModel: ControlDataModel) {
  if (!dataModel) {
    return;
  }
  dataModel.model.__identityCode = '';
  if (dataModel.children && dataModel.children.length > 0) {
    dataModel.children.forEach((s) => clearControlIdentityCode(s));
  }
}
